module.exports = __webpack_public_path__ + "img/drone.94bc130b.png";